(function () {
  'use strict';
  var API = 'https://runway.dcomdtf.app/ma-piece-log/perspective';
  function bounded(value, fallback, min, max) {
    return Number.isFinite(value) ? Math.max(min, Math.min(max, value)) : fallback;
  }
  function position(value, plan) {
    value = value || {};
    return {x:bounded(value.x,plan ? plan.centre.x*100 : 50,0,100),
      y:bounded(value.y,plan ? plan.centre.y*100 : 40,0,100),scale:bounded(value.scale,100,20,150)};
  }
  function validPlan(p) {
    var G = window.AfRoomGeometry;
    return !!(p && G && G.valid(p.coins) && Number.isFinite(p.largeur_cm) && Number.isFinite(p.hauteur_cm)
      && p.largeur_cm>=50 && p.largeur_cm<=2000 && p.hauteur_cm>=30 && p.hauteur_cm<=1000
      && p.centre && Number.isFinite(p.centre.x) && Number.isFinite(p.centre.y)
      && p.centre.x>=0 && p.centre.x<=1 && p.centre.y>=0 && p.centre.y<=1);
  }
  function placement(photo, geo, value) {
    if (!photo || !validPlan(photo.plan) || !(geo.w>0 && geo.h>0)) return null;
    var plan=photo.plan, p=position(value,plan), scale=p.scale/100;
    var rw=geo.w*scale/plan.largeur_cm, rh=geo.h*scale/plan.hauteur_cm;
    if (rw>1 || rh>1) return null;
    var cx=bounded(p.x/100,.5,rw/2,1-rw/2), cy=bounded(p.y/100,.4,rh/2,1-rh/2);
    var matrix=window.AfRoomGeometry.matrix(plan.coins);
    return {slots:geo.slots.map(function(slot){
      var x=cx-rw/2+slot.x*scale/plan.largeur_cm, y=cy-rh/2+slot.y*scale/plan.hauteur_cm;
      var w=slot.w*scale/plan.largeur_cm, h=slot.h*scale/plan.hauteur_cm;
      return [{x:x,y:y},{x:x+w,y:y},{x:x+w,y:y+h},{x:x,y:y+h}].map(function(point){return window.AfRoomGeometry.project(matrix,point);});
    })};
  }
  async function prepare(file) {
    if (!file || !file.type.startsWith('image/') || file.size > 30*1024*1024) throw new Error('photo');
    var url = URL.createObjectURL(file);
    try {
      var image = new Image(); image.src = url; await image.decode();
      var scale = Math.min(1,1600/Math.max(image.naturalWidth,image.naturalHeight));
      var canvas = document.createElement('canvas');
      canvas.width = Math.round(image.naturalWidth*scale); canvas.height = Math.round(image.naturalHeight*scale);
      if (canvas.width<100 || canvas.height<100) throw new Error('photo');
      var ctx = canvas.getContext('2d');
      ctx.fillStyle='#fff'; ctx.fillRect(0,0,canvas.width,canvas.height); ctx.drawImage(image,0,0,canvas.width,canvas.height);
      var blob = await new Promise(function(resolve){canvas.toBlob(resolve,'image/jpeg',.88);});
      if (!blob) throw new Error('photo');
      var small = document.createElement('canvas'), ratio = Math.min(1,320/Math.max(canvas.width,canvas.height));
      small.width = Math.round(canvas.width*ratio); small.height = Math.round(canvas.height*ratio);
      small.getContext('2d').drawImage(canvas,0,0,small.width,small.height);
      var thumb = await new Promise(function(resolve){small.toBlob(resolve,'image/jpeg',.75);});
      var digest = await crypto.subtle.digest('SHA-256',await blob.arrayBuffer());
      var id = Array.from(new Uint8Array(digest),function(n){return n.toString(16).padStart(2,'0');}).join('');
      return {id:id,blob:blob,thumb:thumb,width:canvas.width,height:canvas.height};
    } finally { URL.revokeObjectURL(url); }
  }
  function create(root, changed) {
    var box=root.querySelector('[data-gw-room-controls]'), library=window.AfRoomLibrary;
    if (!box || !library || !window.AfRoomGeometry) return null;
    var find=function(key){return box.querySelector('[data-gw-room-'+key+']');};
    var select=find('select'), upload=find('upload'), input=find('file'), adjust=find('adjust'), retry=find('retry');
    var photo=null, rooms=[], epoch=0, busy=false, storage=true, controller=null;
    var key='affichely:composition:room:v2', saved=null, positions=Object.create(null);
    try { saved=JSON.parse(localStorage.getItem(key)); } catch (_) {}
    if (saved && saved.positions && typeof saved.positions==='object') {
      Object.keys(saved.positions).slice(0,12).forEach(function(id){positions[id]=position(saved.positions[id]);});
    }
    if (!saved) {try {var old=JSON.parse(localStorage.getItem('affichely:composition:room'));if(old)saved={selected:old.selected};}catch (_) {}}
    function roomName(room) {return room.name || box.dataset.roomNumber.replace('__NUMBER__',room.number);}
    function persist() {
      var current=Object.create(null);
      rooms.forEach(function(room){if(positions[room.id])current[room.id]=positions[room.id];});
      try {localStorage.setItem(key,JSON.stringify({selected:photo?photo.id:'',positions:current}));}
      catch (_) {storage=false;}
      find('storage').hidden=storage;
    }
    function failure(message) {find('error').textContent=message||'';find('error').hidden=!message;}
    function setBusy(value) {
      busy=value; retry.disabled=value;
      find('loading').hidden=!value;box.setAttribute('aria-busy',String(value));
      retry.hidden=value || !photo || !!photo.plan;
      adjust.hidden=!photo || !photo.plan;
    }
    function stop() {epoch++;if(controller)controller.abort();controller=null;setBusy(false);}
    function options() {
      var studio=select.options[0].cloneNode(true);select.replaceChildren(studio);
      rooms.forEach(function(room){var option=document.createElement('option');option.value=room.id;option.textContent=roomName(room);select.appendChild(option);});
      select.value=photo?photo.id:'';
      select.hidden=rooms.length===0;
    }
    function sliders() {
      adjust.hidden=!photo || !photo.plan;
      var p=position(photo&&positions[photo.id],photo&&photo.plan);
      ['x','y','scale'].forEach(function(name){find(name).value=p[name];find(name+'-value').textContent=Math.round(p[name])+' %';});
    }
    async function remember(id, patch) {
      var result=await library.update(id,patch);
      rooms=result.library.rooms;storage=storage&&result.library.persistent;
      find('storage').hidden=storage;
      return result.value;
    }
    async function request(url, options, signal) {
      var response=await fetch(url,Object.assign({mode:'cors',credentials:'omit',signal:signal},options));
      if(!response.ok)throw new Error('network');
      return response.json();
    }
    function pause(signal) {
      return new Promise(function(resolve){
        var timer=setTimeout(done,1800);
        function done(){clearTimeout(timer);signal.removeEventListener('abort',done);resolve();}
        signal.addEventListener('abort',done,{once:true});if(signal.aborted)done();
      });
    }
    async function analyse() {
      if(!photo)return;
      stop();var token=epoch,id=photo.id,room=rooms.find(function(r){return r.id===id;});
      if(!room)return;
      controller=new AbortController();var taskController=controller,signal=controller.signal;
      var timeout=setTimeout(function(){if(!signal.aborted)taskController.abort();},120000);
      photo.plan=null;failure('');find('fit').hidden=true;setBusy(true);changed('photo');
      var url=room.photoUntil>Date.now()?room.photoUrl||'':'';
      try {
        var uploadedNow=false;
        if(!url){
          var uploaded=await request(API+'/photo',{method:'POST',headers:{'Content-Type':'image/jpeg'},body:room.blob},signal);
          if(token!==epoch)return;
          url=uploaded.url;uploadedNow=true;
          await remember(id,{photoUrl:url,photoUntil:Date.now()+9*60*1000});
        }
        if(token!==epoch)return;
        var answer=uploadedNow?{etat:'absent'}:await request(API+'?u='+encodeURIComponent(url),{},signal);
        if(answer.etat==='absent')answer=await request(API,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({url:url,width:room.width,height:room.height})},signal);
        while(answer.etat==='en_cours'){
          await pause(signal);if(token!==epoch || signal.aborted)throw new Error('cancelled');
          answer=await request(API+'?u='+encodeURIComponent(url),{},signal);
        }
        if(token!==epoch)return;
        if(answer.etat!=='pret' || !validPlan(answer.plan))throw new Error('plan');
        await remember(id,{plan:answer.plan,analysisVersion:1,photoUrl:'',photoUntil:0});
        if(token!==epoch)return;
        photo.plan=answer.plan;
        if(!positions[id])positions[id]=position(null,photo.plan);
        sliders();persist();
      } catch (_) {
        if(token===epoch){failure(box.dataset.analysisError);await remember(id,{photoUrl:'',photoUntil:0});}
      } finally {
        clearTimeout(timeout);
        if(token===epoch){controller=null;setBusy(false);changed('photo');}
      }
    }
    function choose(id, analyseNow) {
      stop();var room=rooms.find(function(r){return r.id===id;});
      if(photo)URL.revokeObjectURL(photo.url);
      photo=room?{id:room.id,width:room.width,height:room.height,url:URL.createObjectURL(room.blob),
        plan:room.analysisVersion===1 && validPlan(room.plan)?room.plan:null}:null;
      if(photo && photo.plan && !positions[photo.id])positions[photo.id]=position(null,photo.plan);
      select.value=photo?photo.id:'';
      failure('');find('fit').hidden=true;setBusy(false);sliders();persist();changed('photo');
      if(photo && !photo.plan && analyseNow)analyse();
    }
    async function refresh(initial) {
      var token=epoch,result=await library.read();
      if(token!==epoch||busy)return;
      rooms=result.rooms;storage=storage&&result.persistent;options();find('storage').hidden=storage;
      if(initial)choose(saved&&typeof saved.selected==='string'?saved.selected:result.selected,false);
      else if(photo&&!rooms.some(function(r){return r.id===photo.id;}))choose('',false);
    }
    async function importFile(file) {
      if(!file)return;
      stop();var token=epoch;setBusy(true);failure('');
      try {
        var prepared=await prepare(file);if(token!==epoch)return;
        var result=await library.add(prepared);if(token!==epoch)return;
        rooms=result.library.rooms;storage=storage&&result.library.persistent;options();
        setBusy(false);choose(result.value.id,true);
      } catch (_) {if(token===epoch)failure(box.dataset.photoError);}
      finally {if(token===epoch)setBusy(false);input.value='';}
    }
    upload.addEventListener('click',function(){input.click();});
    input.addEventListener('change',function(){importFile(input.files[0]);});
    select.addEventListener('change',function(){choose(select.value,true);});
    select.addEventListener('focus',function(){refresh(false);});
    retry.addEventListener('click',analyse);
    ['x','y','scale'].forEach(function(name){find(name).addEventListener('input',function(){
      if(!photo || !photo.plan)return;
      positions[photo.id][name]=Number(this.value);
      positions[photo.id]=position(positions[photo.id],photo.plan);
      find(name+'-value').textContent=Math.round(positions[photo.id][name])+' %';
      persist();changed('position');
    });});
    options();box.hidden=false;refresh(true);
    return {current:function(){return photo;},placement:function(geo){
      var result=placement(photo,geo,photo&&positions[photo.id]);
      find('fit').hidden=!photo || !photo.plan || !!result;
      return result;
    }};
  }
  window.AfGalleryRoom={create:create,placement:placement,validPlan:validPlan};
})();
